// eslint-disable-next-line no-restricted-imports
import { OverviewCardAmount } from '@george-labs.com/design-system';

import { localizedAmountComponentService } from './LocalizedAmountComponentService';

export const LocalizedOverviewCardAmount = localizedAmountComponentService(
    OverviewCardAmount,
    true,
);
